var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-preferences-new__collapse" }, [
    _c(
      "div",
      {
        staticClass: "search-preferences-new__collapse__label",
        on: {
          click: function ($event) {
            _vm.proxyValue = !_vm.proxyValue
          },
        },
      },
      [
        _c("PtIcon", {
          attrs: {
            icon: _vm.proxyValue ? "SolidDropdownOpen" : "SolidDropdownRight",
          },
        }),
        _vm._t("label"),
      ],
      2
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.proxyValue,
            expression: "proxyValue",
          },
        ],
        staticClass: "search-preferences-new__collapse__content",
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }